/**
 * Allgemeine Informationen:
 *     renderOrder:	Alle Objekte die im Vordergrund liegen (z.B. der Cursor)
 *     				haben die renderOrder 100. Notifications bekommen 200. Normale Objekte 0.
 *     				Aktive Objekte bekommen später 50.
 */
aptis.virtualReality.engine.VREngine = new Class({

	/**
	 * @var {String}
	 */
	_destinationSelector: '',

	/**
	 * @var {String}
	 */
	_name: '',

	/**
	 * @var {String}
	 */
	_description: '',

	/**
	 * @var {Boolean}
	 */
	_publicAvailable: false,

	/**
	 * @var {Number}
	 */
	_worldId: 0,

	/**
	 * @var {Boolean}
	 */
	_debugModeEnabled: false,

	/**
	 * @var {VRDisplay|Null}
	 */
	_vrDisplay: null,

	/**
	 * @var {String}
	 */
	_startSceneId: '',

	/**
	 * @var {Null|THREE.WebGLRenderer}
	 */
	_renderer: null,

	/**
	 * @var {Null|Element}
	 */
	_renderContainer: null,

	/**
	 * @var {Null|jQuery}
	 */
	_renderContainerJQuery: null,

	/**
	 * @var {Null|Element}
	 */
	_renderElement: null,

	/**
	 * @var {Null|jQuery}
	 */
	_renderElementJQuery: null,

	/**
	 * @var {Null|THREE.StereoEffect}
	 */
	_stereoEffect: null,

	/**
	 * @var {Null|THREE.OrbitControls}
	 */
	_controlsOrbitControls: null,

	/**
	 * @var {Null|THREE.DeviceOrientationControls}
	 */
	_controlsDeviceOrientationControls: null,

	/**
	 * Mögliche Werte: orbit, device-orientation.
	 *
	 * @var {String}
	 */
	_currentControlType: '',

	/**
	 * @var {Null|THREE.Camera}
	 */
	_camera: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRObjectCursor}
	 */
	_cursor: null,

	/**
	 * @var {aptis.virtualReality.engine.VRScene[]}
	 */
	_scenes: [],

	/**
	 * @var {Null|aptis.virtualReality.engine.VRScene}
	 */
	_currentScene: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRScene}
	 */
	_emptyScene: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.ThreeJsObjectCreator}
	 */
	_threeJsObjectCreator: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.ObjectPositionManager}
	 */
	_objectPositionManager: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.ConfigObjectCreator}
	 */
	_configObjectCreator: null,

	/**
	 * @var {Null|THREE.Font}
	 */
	_defaultFont: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRRaycasterController}
	 */
	_raycaster: null,

	/**
	 * @var {Number|Null}
	 */
	_rotationX: null,

	/**
	 * @var {Number|Null}
	 */
	_rotationY: null,

	/**
	 * @var {Number|Null}
	 */
	_rotationExactX: null,

	/**
	 * @var {Number|Null}
	 */
	_rotationExactY: null,

	/**
	 * @var {Boolean}
	 */
	_engineIsReady: false,

	/**
	 * @var {aptis.virtualReality.engine.VRMediaController|Null}
	 */
	_mediaController: null,

	/**
	 * @var {THREE.Vector3|Null}
	 */
	_worldDirectionVector: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRToolbarController}
	 */
	_toolbarController: null,

	/**
	 * @var {Null|URLSearchParams}
	 */
	_urlParams: null,

	/*
	* @var {Null|THREE.Frustum}
	*/
	_fovFrustum: null,

	/**
	 * @var {Null|THREE.Matrix4}
	 */
	_cameraViewProjectionMatrix: null,

	/**
	 * @const {Number}
	 */
	SPHERE_RADIUS: 1000,

	/**
	 * @const {Number}
	 */
	MIN_OBJECT_DISTANCE: 50,

	/**
	 * @const {Number}
	 */
	MAX_OBJECT_DISTANCE: 900,

	/**
	 * @const {Number}
	 */
	CAMERA_NEAR: 0.001,

	/**
	 * @const {Number}
	 */
	CAMERA_FAR: 1500,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRAnimationCreator}
	 */
	_animationCreator: null,

	/**
	 * @var {Stats|Null}
	 */
	_debugStatisticFps: null,

	/**
	 * @var {Stats|Null}
	 */
	_debugStatisticMemory: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRRuleController}
	 */
	_ruleController: null,

	/**
	 * @var {Object}
	 */
	_startScreenImage: {},

	/**
	 * @var {Object}
	 */
	_copyrightLogo: {},

	/**
	 * @var {Object}
	 */
	_worldAmbientAudio: {},

	/**
	 * @var {String}
	 */
	_worldAmbientAudioReferenceId: '',

	/**
	 * @var {Null|THREE.Mesh}
	 */
	_copyrightLogoMesh: null,

	/**
	 * @var {Object}
	 */
	_previewBackgroundImage: {},

	/**
	 * @var {Object}
	 */
	_socialMediaPreviewImage: {},

	/**
	 * @var {String}
	 */
	_copyrightText: '',

	/**
	 * @var {Null|THREE.Mesh}
	 */
	_copyrightTextMesh: null,

	/**
	 * @var {String}
	 */
	_copyrightLink: '',

	/**
	 * {Null|aptis.RestCommunicator}
	 */
	_restCommunicator: null,

	/**
	 * @var {aptis.virtualReality.editor.VRHelperLines|Null}
	 */
	_helperLines: null,

	/**
	 * @var {Number}
	 */
	_lastUpdateTime: 0,

	/**
	 * @var {Number}
	 */
	_lastUpdateRotationTime: 0,

	/**
	 * @var {THREE.Vector2}
	 */
	_lastRotationFovUpdate: '',//new THREE.Vector2(0, 0),

	/**
	 * @var {Null|aptis.virtualReality.engine.VRAutorotateController}
	 */
	_autorotateController: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRSoundEffectController}
	 */
	_soundEffectController: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRNotificationController}
	 */
	_notificationController: null,

	/**
	 * @var {aptis.virtualReality.engine.VRHeadUpDisplayController|Null}
	 */
	_headUpDisplayController: null,

	/**
	 * @var {Number}
	 */
	_currentKeyPressed: 0,

	/**
	 * @var {Number}
	 */
	_lastKeyPressedTime: 0,

	/**
	 * @var {Boolean}
	 */
	_changeToSceneInProgress: false,

	/**
	 * @var {Object|Null}
	 */
	_lastMousePosition: null,

	/**
	 * @var {Null|aptis.TickChecker}
	 */
	_tickChecker: null,

	/**
	 * @var {Boolean}
	 */
	_isVrModeEnabled: false,

	/**
	 * @var {String|Null}
	 */
	_renderQuality: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.IconManager}
	 */
	_iconManager: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRObjectDestroyer}
	 */
	_objectDestroyer: null,

	/**
	 * @var {Null|String}
	 */
	_videoQuality: null,

	/**
	 * @var {Null|aptis.virtualReality.engine.VRProfilePageController}
	 */
	_profilePageController: null,

	/**
	 * @var {Null|Object}
	 */
	_socketConfig: null,

	/**
	 * @var {aptis.virtualReality.engine.VRSocketManager|Null}
	 */
	_socketManager: null,

	/**
	 * @var {String}
	 */
	_creatorUserIdOfWorld: '0',

	/**
	 * @var {aptis.virtualReality.engine.VRWebRtcController|Null}
	 */
	_webRtcController: null,

	/**
	 * @var {Null|aptis.MessageManager}
	 */
	_messageManager: null,

	/**
	 * @param {String} destinationSelector
	 * @param {Object} config
	 * @param {Number} worldId
	 * @param {Boolean} debugModeEnabled
	 * @param {Object?} socketConfig
	 */
	initController: function (destinationSelector, config, worldId, debugModeEnabled, socketConfig = null) {
		try {
			var me = this;
			window.socketConfig = socketConfig;

			const configUpdater = new aptis.virtualReality.engine.ConfigUpdater();
			configUpdater.update(config);
			//console.log('VREngine initController___________________________old code');
			//console.log('worldId', worldId);
			//console.log(config);

			this._destinationSelector = destinationSelector;
			this._name = config.name;
			//console.log('name: ',this._name);
			this._description = config.description || '';
			this._publicAvailable = config.publicAvailable;
			this._startSceneId = config.startSceneId;
			this._worldId = worldId;
			this._worldDirectionVector = null;//new THREE.Vector3();
			this._debugModeEnabled = debugModeEnabled;
			this._socketConfig = socketConfig;
			this._creatorUserIdOfWorld = config.creatorUserIdOfWorld || '0';
			if ($j.isArray(config.startScreenImage) && config.startScreenImage.length === 0) {
				config.startScreenImage = {};
			}
			this._startScreenImage = config.startScreenImage || {};
			if ($j.isArray(config.copyrightLogo) && config.copyrightLogo.length === 0) {
				config.copyrightLogo = {};
			}
			this._copyrightLogo = config.copyrightLogo || {};
			if ($j.isArray(config.previewBackgroundImage) && config.previewBackgroundImage.length === 0) {
				config.previewBackgroundImage = {};
			}
			this._previewBackgroundImage = config.previewBackgroundImage || {};
			this._socialMediaPreviewImage = config.socialMediaPreviewImage || {};
			this._copyrightText = config.copyrightText;
			this._copyrightLink = config.copyrightLink;
			if ($j.isArray(config.worldAmbientAudio) && config.worldAmbientAudio.length === 0) {
				config.worldAmbientAudio = {};
			}
			this._worldAmbientAudio = config.worldAmbientAudio || {};
			this._worldAmbientAudioReferenceId = 'worldAmbientAudio';
			this._lastMousePosition = null;

			//Info: DefaultMatrixAutoUpdate muss wegen dem TransformControls im Editor anbleiben
			// if (!this.isInEditor()) {
			// 	THREE.Object3D.DefaultMatrixAutoUpdate = false;
			// }

			this._messageManager = new aptis.MessageManager();

			if (socketConfig) {
				const isMobileDevice = this.isMobileDevice();

				//this._socketManager = new aptis.virtualReality.engine.VRSocketManager(socketConfig);
				//this._socketManager.connect();

				//const uiControllerChat = new aptis.virtualReality.engine.UIControllerChat();
				//uiControllerChat.init(socketConfig, this._socketManager, isMobileDevice);

				// const usersIndicatorController = new aptis.virtualReality.engine.VRUsersIndicatorController();
				// usersIndicatorController.initController(socketConfig.userId, isMobileDevice, this._socketManager, this);

				// this._profilePageController = new aptis.virtualReality.engine.VRProfilePageController();
				// this._profilePageController.initController(this._socketManager, isMobileDevice, this.getRestCommunicator());

				// this._webRtcController = new aptis.virtualReality.engine.VRWebRtcController();
				// this._webRtcController.initController(this);

				$j('body').on('aptis-user-data-updated', (event, userId, newUserData) => {
					if (this._socketConfig && this._socketConfig.userId === userId) {
						this._socketConfig.userName = newUserData.userName || this._socketConfig.userName;
						this._socketConfig.userAvatarUrl = newUserData.userAvatarUrl || this._socketConfig.userAvatarUrl;
					}
				});
			}

			this._getVrDisplay(function (vrDisplay) {
				me._vrDisplay = vrDisplay;
				setTimeout(function () {
					me._initEngineInternal.call(me, destinationSelector, config);
				}, 1000); //Timeout damit alle HTML Ressorucen und iFrames (z.B. für SCORM) geladen sind
			});
		} catch (error) {
			alert('Es ist folgender Fehler beim Laden der VR-Welt aufgetreten: ' + error);
			this._handleError(error);
		}
	},

	/**
	 * @param {Function} mainCallback
	 * @private
	 */
	_getVrDisplay: function (mainCallback) {
		if ('getVRDisplays' in window.navigator) {
			window.navigator.getVRDisplays().then(function (displays) {
				mainCallback(displays[0] || null);
			});
		} else {
			mainCallback(null);
		}
	},

	/**
	 * @param {String} destinationSelector
	 * @param {Object} config
	 * @private
	 */
	_initEngineInternal: function (destinationSelector, config) {
		var me = this;

		// this._mediaController = new aptis.virtualReality.engine.VRMediaController();
		// this._mediaController.initController(this);


		const mainMenuController = new aptis.virtualReality.engine.VRMainMenuController();
		mainMenuController.initController(this);

		console.log('VRMainMenuController');

		// this._iconManager = new aptis.virtualReality.engine.IconManager();
		// this._iconManager.initManager(config.customIcons || {}, config.elementTypeIconAssignments || {});

		// var fontLoader = new THREE.FontLoader();
		// this._defaultFont = fontLoader.parse(aptis.virtualReality.engine.fonts.optimerRegular);

		// this._renderer = new THREE.WebGLRenderer({
		// 	antialias: true,
		// 	stencil: false,
		// 	powerPreference: 'high-performance',
		// 	physicallyCorrectLights: true,
		// 	precision: 'mediump',
		// });
		// this._renderer.autoClear = false;

		// if (this.isMobileDevice()) {
		// 	this.setRenderQuality('high');
		// 	this.setVideoQuality('normal');
		// } else {
		// 	this.setRenderQuality('normal');
		// 	this.setVideoQuality('normal');
		// }

		// this._renderer.localClippingEnabled = true;

		// if (this._vrDisplay) {
		// 	try {
		// 		document.body.appendChild(WEBVR.createButton(this._renderer));
		// 		this._renderer.vr.enabled = true;
		// 		this._renderer.vr.setDevice(this._vrDisplay);
		// 	} catch (exception) {
		// 		this._vrDisplay = null;
		// 		if (window.console) {
		// 			console.error('Fehler beim Initialisieren von WebVR:', exception);
		// 		}
		// 	}
		// }

		// this._renderElement = this._renderer.domElement;
		// this._renderElementJQuery = $j(this._renderElement);

		// this._renderContainerJQuery = $j(this._destinationSelector);
		// this._renderContainer = this._renderContainerJQuery[0];
		// this._renderContainer.appendChild(this._renderElement);

		// this._renderElementJQuery.addClass('aptisVirtualRealityCanvas');

		// this._tickChecker = new aptis.TickChecker();
		// this._tickChecker.addCheck('raycasterUpdateCheck', 100, function() {
		// 	if (me.cursorIsMouse()) {
		// 		if (me._lastMousePosition) {
		// 			let mousePosition = me._calculateCenteredPosition(me._lastMousePosition.x, me._lastMousePosition.y, me._renderElementJQuery.width(), me._renderElementJQuery.height());
		// 			me._raycaster.check(me._currentScene, 'check', mousePosition);
		// 		}
		// 	} else {
		// 		me._raycaster.check(me._currentScene, 'check', {x: 0, y: 0});
		// 	}
		// });

		// if (!this._vrDisplay) {
		// 	this._toolbarController = new aptis.virtualReality.engine.VRToolbarController();
		// 	this._toolbarController.initController(this, destinationSelector);
		// }

		// if (this.isiOSDevice()) {
		// 	$j(destinationSelector).find('.ios-device-orientation-info').show();
		// }

		/* TODO SPÄTER WIERDER AUFNEHMEN
		if (this._debugModeEnabled) {
			$j(destinationSelector).append('<div id="debug"></div>');
			this._debugContainer = document.getElementById('debug');

			$j('body').append('<div class="debug-statistic-container"></div>');

			this._debugStatisticFps = new Stats();
			this._debugStatisticFps.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
			$j('.debug-statistic-container').append(this._debugStatisticFps.dom);

			this._debugStatisticMemory = new Stats();
			this._debugStatisticMemory.showPanel(2); // 0: fps, 1: ms, 2: mb, 3+: custom
			$j('.debug-statistic-container').append(this._debugStatisticMemory.dom);

			//setInterval(function() {
			//	console.debug('Render-Info: ', me._renderer.info);
			//}, 5000);
		}*/

		// let currentFov = this._getUrlParams().get('fov');
		// if (!currentFov || !$j.isNumeric(currentFov) || currentFov < 10 || currentFov > 160) {
		// 	currentFov = 70;
		// }

		// let width = this._renderContainerJQuery.width();
		// let height = this._renderContainerJQuery.height();
		// this._camera = new THREE.PerspectiveCamera(currentFov, width / height, this.CAMERA_NEAR, this.CAMERA_FAR);
		// this._camera.matrixAutoUpdate = true;
		// this._camera.position.set(0.00000000000001, 0.00000000000001, 0.00000000000001);

		// this._emptyScene = new THREE.Scene();
		// this._emptyScene.add(this._camera);

		// var cursorConfig = {
		// 	type: 'cursor',
		// 	camera: this._camera,
		// 	x: 0,
		// 	y: 0
		// };
		// this._cursor = this.getConfigObjectCreator().createObject(this, null, cursorConfig);
		// this._cursor.createObject();

		// this._controlsOrbitControls = new THREE.OrbitControls(this._camera, this._renderElement);
		// this._controlsOrbitControls.target.set(0, 0, 0);
		// this._controlsOrbitControls.enableZoom = false;
		// this._controlsOrbitControls.enablePan = false;
		// this._controlsOrbitControls.enableDamping = true;
		// this._controlsOrbitControls.dampingFactor = 0.15;
		// this._controlsOrbitControls.rotateSpeed = 0.15;

		// me.switchControls('orbit');

		// this._headUpDisplayController = new aptis.virtualReality.engine.HeadUpDisplayController();
		// this._headUpDisplayController.initRenderer(this, width, height);

		// this._showCopyright();

		// this._raycaster = new aptis.virtualReality.engine.VRRaycasterController(this, this._camera);

		// this._initScenesFromConfig(config.scenes);

		// this._soundEffectController = new aptis.virtualReality.engine.VRSoundEffectController();
		// this._soundEffectController.initController(this);

		// this._ruleController = new aptis.virtualReality.engine.VRRuleController();
		// this._ruleController.initController(this, config.rules || {});

		// this._autorotateController = new aptis.virtualReality.engine.VRAutorotateController();
		// this._autorotateController.initController(this);

		// this._notificationController = new aptis.virtualReality.engine.VRNotificationController();
		// this._notificationController.initController(this);

		// const deviceOrientationChangedHandler = function (event) {
		// 	if (!event.alpha) {
		// 		return;
		// 	}

		// 	me._controlsDeviceOrientationControls = new THREE.DeviceOrientationControls(me._camera);
		// 	me._controlsDeviceOrientationControls.connect();
		// 	me._controlsDeviceOrientationControls.update();
		// 	$j('body').trigger('aptisDeviceOrientationControlsInitialized', [me._currentControlType]);

		// 	$j('.ios-device-orientation-info').hide();

		// 	window.removeEventListener('deviceorientation', deviceOrientationChangedHandler, true);
		// };
		// window.addEventListener('deviceorientation', deviceOrientationChangedHandler, true);

		// window.addEventListener('resize', $j.proxy(this._resize, me), false);

		// this._registerInputHandlers();

		// $j(document).on('aptisVrRotationChange', function(event, rotationChange) {
		// 	if (rotationChange < 5) {
		// 		me._updateFov();
		// 	}
		// });

		// this._setEngineIsReady();
		// this._initFirstScene();
		// const startFocusPosition = this.getStartFocusPosition();
		// this.getObjectPositionManager().setPosition(this.getCurrentCamera(), startFocusPosition.x, startFocusPosition.y, -0.00000000000001);
		// this.setWorldAmbientAudio(this._worldAmbientAudio);

		// this._resize();
		// this._renderer.setAnimationLoop($j.proxy(this._animate, this));

		//if (this.isInEditor()) {
		// this._helperLines = new aptis.virtualReality.editor.VRHelperLines(this);
		// this._helperLines.getHelperLinesGroup().updateMatrix();
		// let currentScene = this.getCurrentScene();
		// if (currentScene) {
		// 	currentScene.addThreeObject(this._helperLines.getHelperLinesGroup());
		// }
		//}

		if (!this.isMobileDevice()) {
			$j('body').on('keydown', function (event) {
				const hasFocusOnlyInEngine = !$j(document.activeElement).is('input, button, textarea, .ui-slider-handle');
				if (hasFocusOnlyInEngine) {
					me._lastKeyPressedTime = me._lastKeyPressedTime || new Date().getTime();
					me._currentKeyPressed = event.keyCode;
				}
			});

			$j('body').on('keyup', function () {
				me._currentKeyPressed = 0;
				me._lastKeyPressedTime = 0;
			});
		}

		let isMutedBeforeFocusLost = false;
		const visibilityHandler = new aptis.WindowVisibilityHandler();
		visibilityHandler.registerIfVisible(function () {
			if (!isMutedBeforeFocusLost) {
				me.getMediaController().unmuteAll();
			}
		});

		visibilityHandler.registerIfHidden(function () {
			isMutedBeforeFocusLost = me.getMediaController().isAllMuted();
			me.getMediaController().muteAll();
		});



		// const moodController = new aptis.virtualReality.engine.VRMoodController();
		// moodController.initController();

		$j(window).on('orientationchange', function () {
			me._orientationChangHandler();
		});

		$j('body').on('aptisGlobalWorldSettingsChanged', function () {
			me._showCopyright();
		});
	},

	/**
	 * @private
	 */
	_registerInputHandlers: function () {
		const me = this;

		//Klick nur akzeptieren, wenn man seit mouseDown nicht nicht sie Kamera rotiert hat (Abweichung 2 < Grad)
		let lastRotationX = 0;
		let lastRotationY = 0;
		const mouseDownEventName = this.isMobileDevice() ? 'touchstart' : 'mousedown';
		window.addEventListener(mouseDownEventName, function () {
			lastRotationX = me.getRotationX();
			lastRotationY = me.getRotationY();
		}, false);

		const mouseUpEventName = this.isMobileDevice() ? 'touchend' : 'mouseup';
		window.addEventListener(mouseUpEventName, function (event) {
			if (Math.abs(lastRotationX - me.getRotationX()) < 2 && Math.abs(lastRotationY - me.getRotationY()) < 2) {
				me._clickedHandler.call(me, event);
			}
		}, false);

		//Maus Position bei mousemove speichern (Anders kommt man nicht an die Position)
		if (this.cursorIsMouse()) {
			window.addEventListener('mousemove', function (event) {
				me._lastMousePosition = me._lastMousePosition || {};
				if (event.changedTouches && event.changedTouches.length > 0) {
					me._lastMousePosition.x = event.changedTouches[0].clientX;
					me._lastMousePosition.y = event.changedTouches[0].clientY;
				} else {
					me._lastMousePosition.x = event.clientX;
					me._lastMousePosition.y = event.clientY;
				}
			}, false);
		}
	},

	/**
	 * @private
	 */
	_setEngineIsReady: function () {
		if (!this._engineIsReady) {
			this._engineIsReady = true;
			$j('body').trigger('aptisVrEngineIsReady');
		}
	},

	/**
	 * @param {String} type
	 */
	switchControls: function (type) {
		if (this._currentControlType === type) {
			return;
		}
		this._currentControlType = type;

		switch (type) {
			case 'orbit':
				this._controlsOrbitControls.enabled = true;
				this._controlsOrbitControls.target.set(0, 0, 0);
				if (this._controlsDeviceOrientationControls) {
					this._controlsDeviceOrientationControls.enabled = false;
				}
				break;
			case 'device-orientation':
				if (this._controlsDeviceOrientationControls) {
					this._controlsDeviceOrientationControls.enabled = true;
					this._controlsOrbitControls.enabled = false;
				} else {
					this._controlsOrbitControls.enabled = true;
					this._controlsOrbitControls.target.set(0, 0, 0);
					this._currentControlType = 'orbit';
				}
				break;
			default:
				if (window.console) {
					console.error('Unknown controls type "' + type + '".');
				}
		}

		$j('body').trigger('aptisControlsSwitched', [this._currentControlType]);
	},

	/**
	 * @private
	 */
	_initFirstScene: function () {
		let startScene = null;
		const startVrObject = this.findObjectById(this._getUrlParams().get('startObject'));
		if (startVrObject) {
			startScene = startVrObject.getScene();
		} else {
			startScene = this.findSceneById(this._startSceneId);
		}

		const startFocusPosition = this.getStartFocusPosition();
		if (startScene) {
			this.changeToScene(startScene, startFocusPosition, null, 'none');
		} else if (this._scenes && this._scenes.length > 0) {
			this.changeToScene(this._scenes[0], startFocusPosition, null, 'none');
		}
	},

	/**
	 * @param {Object} scenesConfig
	 * @private
	 */
	_initScenesFromConfig: function (scenesConfig) {
		if (!scenesConfig) {
			return;
		}

		var me = this;
		$j.each(scenesConfig, function (index, sceneConfig) {
			var newScene = new aptis.virtualReality.engine.VRScene();
			newScene.initScene(me, sceneConfig);
			me.addScene.call(me, newScene);
		});
	},

	/**
	 * @param {aptis.virtualReality.engine.VRScene} newScene
	 */
	addScene: function (newScene) {
		this._scenes.push(newScene);
		$j('body').trigger('aptisSceneAdded', [newScene]);
	},

	/**
	 * @return {Boolean}
	 */
	isMobileDevice: function () {
		const userAgent = window.navigator.userAgent.toLowerCase();
		return userAgent.search('android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i') > -1 ||
			(userAgent.search('macintosh') > -1 && 'ontouchend' in document); //Workaround: iPad hat standardmäßig den "Desktopseite anfordern" Modus an. Dann wird kein iPad User Agent mitgeschickt
	},

	/**
	 * @return {Boolean}
	 */
	isiOSDevice: function () {
		const userAgent = window.navigator.userAgent.toLowerCase();
		return userAgent.search('iphone|ipad|ipod/i') > -1 ||
			(userAgent.search('macintosh') > -1 && 'ontouchend' in document); //Workaround: iPad hat standardmäßig den "Desktopseite anfordern" Modus an. Dann wird kein iPad User Agent mitgeschickt
	},

	/**
	 * @return {Boolean}
	 */
	isSafariBrowser: function () {
		const userAgent = window.navigator.userAgent.toLowerCase();
		return userAgent.search('safari/i') > -1
	},

	/**
	 * @return {boolean}
	 */
	isVRHeadset: function () {
		return this._vrDisplay ? true : false;
	},

	/**
	 * @private
	 */
	_animate: function () {
		try {
			if (this._debugStatisticFps) {
				this._debugStatisticFps.begin();
				this._debugStatisticMemory.begin();
			}

			//FPS reduzieren (Weniger performance beim Testen):
			//window.aptisLast = window.aptisLast || 0;
			//const now = new Date().getTime()
			//if (now - window.aptisLast < 200) {
			//	return;
			//}
			//window.aptisLast = now;

			// Zuerst muss das rendern gemacht werden, dann erst das update. Da es sonst beim ersten Mal
			// dazu kommt, das alle Elemente z.B. besucht sind. Der Raycaster kommt wohl nicht damit klar.
			// Daher hier diese "komische" Reihenfolge.
			//this._render();
			//this._update();

			if (this._debugStatisticFps) {
				this._debugStatisticFps.end();
				this._debugStatisticMemory.end();
			}
		} catch (exception) {
			this._handleError(exception);
		}
	},

	/**
	 * @private
	 */
	_update: function () {
		// const me = this;

		// this._lastUpdateTime = new Date().getTime();

		// try {
		// 	this._updateRotationPosition();

		// 	if (this._currentScene && this._engineIsReady) {
		// 		this._tickChecker.checkByKey('raycasterUpdateCheck');
		// 		this._rotateCameraWithKeyboard();
		// 		this._currentScene.update();
		// 	}

		// 	if (this._debugContainer) {
		// 		var newDebugText = this.getRotationX() + ' x ' + this.getRotationY();
		// 		if (this._debugContainer.innerHTML !== newDebugText) {
		// 			this._debugContainer.innerHTML = newDebugText;
		// 		}
		// 	}

		// 	this.getCurrentControls().update();

		// 	//Nur alle 250 ms prüfen ob man den FOV aktualisieren muss
		// 	if (this._lastUpdateTime - this._lastUpdateRotationTime > 250) {
		// 		//Wärend man mit der Kamera schwenkt, wird die FOV nicht aktualisiert (Vermeidet so Ruckler beim Bewegen)
		// 		//const cameraSpeed = Math.max(Math.abs(this._rotationX - this._lastRotationFovUpdate.x), Math.abs(this._rotationY - this._lastRotationFovUpdate.y)) % 360;
		// 		//$j('body').trigger('aptisVrRotationChange', [cameraSpeed]);

		// 		//this._lastRotationFovUpdate.set(this._rotationX, this._rotationY);
		// 		//this._lastUpdateRotationTime = this._lastUpdateTime;
		// 	}

		// 	TWEEN.update();
		// } catch (exception) {
		// 	this._handleError(exception);
		// }
	},

	/**
	 * @private
	 */
	_updateRotationPosition: function () {
		// var x = 0;
		// var y = 0;

		// let currentControls = this.getCurrentControls();
		// if (currentControls.getAzimuthalAngle) {
		// 	x = currentControls.getAzimuthalAngle();
		// 	y = currentControls.getPolarAngle();
		// 	x = THREE.Math.radToDeg(x);
		// 	y = THREE.Math.radToDeg(y);
		// } else {
		// 	var cameraDirection = this._camera.getWorldDirection(this._worldDirectionVector);
		// 	var phi = Math.acos(cameraDirection.y);
		// 	var theta = Math.atan2(cameraDirection.x, cameraDirection.z);
		// 	theta = Math.atan2(Math.sin(theta), Math.cos(theta));
		// 	x = THREE.Math.radToDeg(theta) - 180;
		// 	y = 180 - THREE.Math.radToDeg(phi);
		// }

		// x = x < 0 ? 360 + x : x;

		// this._rotationX = Math.round(x);
		// this._rotationY = Math.round(y);

		// this._rotationExactX = x;
		// this._rotationExactY = y;

	},

	/**
	 * @private
	 */
	_showCopyright: function () {
		const me = this;

		if (me._copyrightLogoMesh) {
			this._headUpDisplayController.getScene().unregisterObjectsForRaycaster(this._copyrightLogoMesh);
			this._headUpDisplayController.removeObject(me._copyrightLogoMesh);
			this._copyrightLogoMesh.geometry.dispose();
			this._copyrightLogoMesh.material.dispose();
			delete me._copyrightLogoMesh;
		}

		const maxLogoSize = 150;
		let copyrightLogoWidth = maxLogoSize;

		if (this._copyrightLogo && this._copyrightLogo.mediumPath) {
			const copyrightLogoMaterial = this._threeJsObjectCreator.createMediumMaterial(this._copyrightLogo, null, function (mediumWidth, mediumHeight) {
				let spaceToBorder = 0;
				let copyrightLogoHeight = mediumHeight / mediumWidth * maxLogoSize;
				if (mediumWidth < mediumHeight) {
					copyrightLogoWidth = mediumWidth / mediumHeight * maxLogoSize;
					copyrightLogoHeight = maxLogoSize;
					spaceToBorder = copyrightLogoWidth;
				} else {
					spaceToBorder = copyrightLogoWidth;
				}

				me._copyrightLogoMesh = me._threeJsObjectCreator.createPlane(copyrightLogoWidth, copyrightLogoHeight, copyrightLogoMaterial);
				me._headUpDisplayController.addObject(me._copyrightLogoMesh, 'bottom-left');

				if (me._copyrightLink && me._copyrightLink !== '') {
					me._headUpDisplayController.getScene().registerObjectsForRaycaster(me._copyrightLogoMesh, ['runAction'], function (event, parameters) {
						switch (event) {
							case 'runAction':
								window.open(me.getCopyrightLink(), '_blank');
								break;
						}
					});
				}

				me._showCopyrightText(spaceToBorder);
			});
		} else {
			me._showCopyrightText(0);
		}
	},

	/**
	 * @param {Number} spaceToBorder
	 * @private
	 */
	_showCopyrightText: function (spaceToBorder) {
		const me = this;

		if (this._copyrightTextMesh) {
			this._headUpDisplayController.getScene().unregisterObjectsForRaycaster(this._copyrightTextMesh);
			this._headUpDisplayController.removeObject(me._copyrightTextMesh);
			this._copyrightTextMesh.geometry.dispose();
			this._copyrightTextMesh.material.dispose();
			delete me._copyrightTextMesh;
		}

		if (this._copyrightText && this._copyrightText !== '') {
			this._threeJsObjectCreator.createHtmlMesh(this._copyrightText, me._renderContainerJQuery.width(), 'transparent', 'white', 5, '0px 0px 6px black').then(function (mesh) {
				me._copyrightTextMesh = mesh;

				me._headUpDisplayController.addObject(mesh, 'bottom-left', spaceToBorder);

				if (me._copyrightLink && me._copyrightLink !== '') {
					me._headUpDisplayController.getScene().registerObjectsForRaycaster(mesh, ['runAction'], function (event, parameters) {
						switch (event) {
							case 'runAction':
								window.open(me.getCopyrightLink(), '_blank');
								break;
						}
					});
				}
			});
		}
	},

	/**
	 * @private
	 */
	_resize: function () {
		try {
			if (this._vrDisplay && this._vrDisplay.isPresenting) {
				return;
			}

			let width = this._renderContainerJQuery.width();
			let height = this._renderContainerJQuery.height();
			this._camera.aspect = width / height;
			this._camera.updateProjectionMatrix();

			this._headUpDisplayController.setSize(width, height);

			this._renderer.setSize(width, height, true);
			this.setRenderQuality(this._renderQuality);
			if (this._slideInController) {
				this._slideInController.updateQualityButtons();
			}

			if (this._stereoEffect) {
				this._stereoEffect.setSize(width, height);
			}
		} catch (exception) {
			this._handleError(exception);
		}
	},

	/**
	 * @returns {Boolean}
	 */
	isFullScreen: function () {
		return !(document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement);
	},

	/**
	 * @private
	 */
	_render: function () {
		if (!this._engineIsReady) {
			return;
		}
		try {
			let sceneForRendering = this._currentScene ? this._currentScene.getScene() : this._emptyScene;
			if (this._vrDisplay && !this._vrDisplay.isPresenting) {
				sceneForRendering = this._emptyScene;
			}
			const currentRenderer = this._stereoEffect ? this._stereoEffect : this._renderer;
			currentRenderer.render(sceneForRendering, this._camera);
			this._headUpDisplayController.render(this._renderer);
		} catch (exception) {
			this._handleError(exception);
		}
	},

	/**
	 * @param {String} sceneId
	 * @param {Null|{x: Number, y: Number}?} startFocusPosition
	 * @param {Null|THREE.Vector2?} rotateToPositionBeforeAnimation
	 * @param {String?} transitionAnimation
	 */
	changeToSceneById: function (sceneId, startFocusPosition = null, rotateToPositionBeforeAnimation = null, transitionAnimation) {
		this.changeToScene(this.findSceneById(sceneId), startFocusPosition, rotateToPositionBeforeAnimation, transitionAnimation)
	},

	/**
	 * @param {aptis.virtualReality.engine.VRScene} scene
	 * @param {Null|{x: Number, y: Number}?} startFocusPosition
	 * @param {Null|THREE.Vector2?} rotateToPositionBeforeAnimation
	 * @param {String?} transitionAnimation
	 */
	changeToScene: function (scene, startFocusPosition = null, rotateToPositionBeforeAnimation = null, transitionAnimation = 'rotateAndFlow') {
		const me = this;

		if (!scene) {
			return;
		}

		if (this._changeToSceneInProgress) {
			return;
		}
		this._changeToSceneInProgress = true;

		this._beforeChangeToScene();
		this.updateCursorStatus('loadingWait', 0);

		scene.createScene(function () {
			if (me.getCurrentControlType() === 'orbit') {
				me.getCurrentControls().enabled = false;
			}

			me.updateCursorStatus('normal');

			startFocusPosition = startFocusPosition || {
				x: (scene.getStartPositionX() || me.getRotationX() || 0),
				y: (scene.getStartPositionY() || me.getRotationY() || 90),
			};

			rotateToPositionBeforeAnimation = rotateToPositionBeforeAnimation || {
				x: me.getRotationX(),
				y: me.getRotationY(),
			};

			switch (transitionAnimation) {
				case 'rotateAndFlow':
					const animationCreator = me.getAnimationCreator();
					animationCreator.startTweensAsChain([
						animationCreator.createObjectRotationAnimation(rotateToPositionBeforeAnimation, me.getCurrentControls(), 500),
						animationCreator.createMoveCameraInDistanceAnimation(0, 300, TWEEN.Easing.Cubic.In, 500, rotateToPositionBeforeAnimation, function () {
							me._changeToSceneStepLoadNewScene.call(me, scene);
						}),
						animationCreator.createMoveCameraInDistanceAnimation(-300, 0, TWEEN.Easing.Cubic.Out, 500, startFocusPosition, function () {
							me._afterChangeToScene.call(me, scene, startFocusPosition);
						})
					]);
					break;
				default:
					me._changeToSceneStepLoadNewScene(scene);
					me._afterChangeToScene(scene, startFocusPosition);
					break;
			}

			me._changeToSceneInProgress = false;
		});
	},

	/**
	 * @param {aptis.virtualReality.engine.VRScene} scene
	 * @param {Number} percentage
	 */
	updateSceneLoadingProgress: function (scene, percentage) {
		if (this._changeToSceneInProgress && !scene.isCurrentShownScene()) {
			this.updateCursorStatus('loadingWait', percentage);
		}
	},

	/**
	 * @param {aptis.virtualReality.engine.VRScene} scene
	 * @private
	 */
	_beforeChangeToScene: function (scene) {
		this.disableRaycaster();

		$j('body').trigger('aptisBeforeSceneChange', [this._currentScene, scene]);
	},

	/**
	 * @param {aptis.virtualReality.engine.VRScene} scene
	 * @private
	 */
	_changeToSceneStepLoadNewScene: function (scene) {
		const objectPositionManager = this.getObjectPositionManager();
		objectPositionManager.setPosition(this.getCurrentControls(), 0, 0, 0);
		objectPositionManager.setPosition(this.getCurrentCamera(), 0, 0, -0.000000000001);
		this._loadAndShowScene(scene);
	},

	/**
	 * @param {aptis.virtualReality.engine.VRScene} scene
	 * @param {Null|{x: Number, y: Number}} startFocusPosition
	 * @private
	 */
	_afterChangeToScene: function (scene, startFocusPosition) {
		if (this.getCurrentControlType() === 'orbit') {
			this.getCurrentControls().enabled = true;
		}

		this.getObjectPositionManager().setPosition(this.getCurrentCamera(), startFocusPosition.x, startFocusPosition.y, -0.000000000001);

		this.enableRaycaster();
		this._raycaster.disableRaycasterUntilNextMove();

		$j('body').trigger('aptisSceneChanged', [this._currentScene]);

		this.updateCursorStatus('normal');
	},

	/**
	 * @param {aptis.virtualReality.engine.VRScene} scene
	 *
	 */
	_loadAndShowScene: function (scene) {
		if (this._currentScene) {
			this._currentScene.removeThreeObject(this._camera);
			if (this.isInEditor()) {
				this._currentScene.removeThreeObject(this._helperLines.getHelperLinesGroup());
			}
			this._currentScene = null;
		}

		this._currentScene = scene;
		this._currentScene.addThreeObject(this._camera);
		if (this.isInEditor() && this._helperLines !== null) {
			this._currentScene.addThreeObject(this._helperLines.getHelperLinesGroup());
		}
		this._currentScene.initAudio();
		this._currentScene.setIsVisited();
	},

	/**
	 * @param {String} sceneId
	 * @return {Null|aptis.virtualReality.engine.VRScene}
	 */
	findSceneById: function (sceneId) {
		var foundScene = null;
		$j.each(this._scenes, function (index, scene) {
			if (scene.getId() === sceneId) {
				foundScene = scene;
				return false; //Break
			}
		});
		return foundScene;
	},

	/**
	 * @return {aptis.virtualReality.engine.ThreeJsObjectCreator}
	 */
	getThreeJsObjectCreator: function () {
		// if (!this._threeJsObjectCreator) {
		// 	this._threeJsObjectCreator = new aptis.virtualReality.engine.ThreeJsObjectCreator(this);
		// }
		// return this._threeJsObjectCreator;
	},

	/**
	 * @return {aptis.virtualReality.engine.ObjectPositionManager}
	 */
	getObjectPositionManager: function () {
		if (!this._objectPositionManager) {
			this._objectPositionManager = new aptis.virtualReality.engine.ObjectPositionManager();
			this._objectPositionManager.mediaController = this.getMediaController();
		}
		return this._objectPositionManager;
	},

	/**
	 * @return {aptis.virtualReality.engine.ConfigObjectCreator}
	 */
	getConfigObjectCreator: function () {
		if (!this._configObjectCreator) {
			this._configObjectCreator = new aptis.virtualReality.engine.ConfigObjectCreator();
		}
		return this._configObjectCreator;
	},

	/**
	 * @return {aptis.virtualReality.engine.VRMediaController}
	 */
	getMediaController: function () {
		return this._mediaController;
	},

	/**
	 * @return {THREE.Camera}
	 */
	getCurrentCamera: function () {
		return this._camera;
	},

	/**
	 * @var {Null|THREE.Font}
	 */
	getDefaultFont: function () {
		return this._defaultFont;
	},

	/**
	 * @param {String} status
	 * @param {Number?} parameter1
	 */
	updateCursorStatus: function (status, parameter1) {
		this._cursor.updateCursorStatus(status, parameter1);
	},

	/**
	 * @return {String}
	 */
	getCursorStatus: function () {
		return this._cursor.getCursorStatus();
	},

	/**
	 * @param {String} objectId
	 * @return {Null|aptis.virtualReality.engine.VRObject}
	 */
	findObjectById: function (objectId) {
		var foundObject = null;
		$j.each(this._scenes, function (index, scene) {
			var currentFoundObject = scene.findObjectById(objectId);
			if (currentFoundObject) {
				foundObject = currentFoundObject;
				return false; //Break
			}
		});
		return foundObject;
	},

	/**
	 * @param {String} objectId
	 */
	deleteObject: function (objectId) {
		var object = this.findObjectById(objectId);
		if (object) {
			object.deleteObject();
		}
	},

	/**
	 * @param {String} sceneId
	 */
	deleteScene: function (sceneId) {
		for (var i = 0; i < this._scenes.length; i++) {
			if (this._scenes[i].getId() === sceneId) {
				this._scenes.splice(i, 1);
				$j('body').trigger('aptisSceneRemoved', [sceneId]);
				break;
			}
		}
	},

	/**
	 * @param {Number} x
	 * @param {Number} y
	 * @param {Number?} duration
	 * @param {Function?} completedHandler
	 */
	rotateToPointAnimated: function (x, y, duration = 500, completedHandler = null) {
		this.getAnimationCreator().createCameraRotationAnimation(new THREE.Vector2(x, y), duration, completedHandler).start();
	},

	/**
	 * @param {aptis.virtualReality.engine.VRObject} object
	 */
	rotateToObject: function (object) {
		if (object) {
			this.rotateToPointAnimated(object.getPositionX(), object.getPositionY());
		}
	},

	/**
	 * @return {Number}
	 */
	getRotationX: function () {
		return this._rotationX;
	},

	/**
	 * @return {Number}
	 */
	getRotationY: function () {
		return this._rotationY;
	},

	/**
	 * @param {String} error
	 * @private
	 */
	_handleError: function (error) {
		if (window.console) {
			console.error('VR-Engine Fehler', error);
		}
	},

	/**
	 * @returns {Object}
	 */
	getCurrentConfig: function () {
		var scenesConfig = [];
		$j.each(this._scenes, function (index, scene) {
			console.log(scenesConfig);
			scenesConfig.push(scene.getCurrentConfig());
		});

		const configUpdater = new aptis.virtualReality.engine.ConfigUpdater();
		console.log(window.scenesconfig);
		console.log(configUpdater);

		//return window.scenesconfig;
		//console.log ('version: ', configUpdater.CURRENT_VERSION );
		//console.log ('name: ', this.getName());
		//version: configUpdater.CURRENT_VERSION,
		//name: this.getName(),
		// 	description: this.getDescription(),
		// 	publicAvailable: this.isPublicAvailable(),
		// 	startSceneId: this._startSceneId,
		// 	scenes: scenesConfig,
		// 	rules: this._ruleController.getRules(),
		// 	copyrightLogo: this.getCopyrightLogo(),
		// 	previewBackgroundImage: this.getPreviewBackgroundImage(),
		// 	socialMediaPreviewImage: this.getSocialMediaPreviewImage(),
		// 	copyrightText: this.getCopyrightText(),
		// 	copyrightLink: this.getCopyrightLink(),
		// 	worldAmbientAudio: this.getWorldAmbientAudio(),
		// 	customIcons: this._iconManager.getCustomIcons(),
		// 	elementTypeIconAssignments: this._iconManager.getElementTypeIconAssignments(),
		// });		
		return {
			version: configUpdater.CURRENT_VERSION,
			name: this.getName(),
			description: this.getDescription(),
			publicAvailable: this.isPublicAvailable(),
			startSceneId: this._startSceneId,
			scenes: window.scenesconfig.scenes, //scenesConfig,
			rules: this._ruleController.getRules(),
			copyrightLogo: this.getCopyrightLogo(),
			previewBackgroundImage: this.getPreviewBackgroundImage(),
			socialMediaPreviewImage: this.getSocialMediaPreviewImage(),
			copyrightText: this.getCopyrightText(),
			copyrightLink: this.getCopyrightLink(),
			worldAmbientAudio: this.getWorldAmbientAudio(),
			//customIcons: this._iconManager.getCustomIcons(),
			//elementTypeIconAssignments: this._iconManager.getElementTypeIconAssignments(),
		};
	},

	/**
	 * @return {String}
	 */
	getName: function () {
		return this._name;
	},

	/**
	 * @param {String} name
	 */
	setName: function (name) {
		this._name = name;
	},

	/**
	 * @return {String}
	 */
	getDescription: function () {
		return this._description;
	},

	/**
	 * @param {String} description
	 */
	setDescription: function (description) {
		this._description = description;
	},

	/**
	 * @returns {Boolean}
	 */
	isPublicAvailable: function () {
		return this._publicAvailable;
	},

	/**
	 * @param {Boolean} publicAvailable
	 */
	setPublicAvailable: function (publicAvailable) {
		this._publicAvailable = publicAvailable;
	},

	/**
	 * @return {String}
	 */
	getCopyrightText: function () {
		return this._copyrightText;
	},

	/**
	 * @param {String} copyrightText
	 */
	setCopyrightText: function (copyrightText) {
		this._copyrightText = copyrightText;
	},

	/**
	 * @returns {String}
	 */
	getCopyrightLink: function () {
		return this._copyrightLink;
	},

	/**
	 * @param {String} link
	 */
	setCopyrightLink: function (link) {
		this._copyrightLink = link;
	},

	/**
	 * @return {aptis.virtualReality.engine.VRScene[]}
	 */
	getScenes: function () {
		return this._scenes;
	},

	/**
	 * @param {String} sceneId
	 * @param {Number} newIndex
	 */
	moveSceneToIndex: function (sceneId, newIndex) {
		let sceneIndex = null;
		$j.each(this._scenes, function (index, scene) {
			if (scene.getId() === sceneId) {
				sceneIndex = index;
				return false; //Break
			}
		});

		if (sceneIndex !== null) {
			this._scenes.splice(newIndex, 0, this._scenes.splice(sceneIndex, 1)[0]);
		}
	},

	makeFullScreen: function () {
		//Leider geht der Fullscreen bei iOS nicht (man muss das Gerät einfach auf die Seite drehen)
		if (this.isiOSDevice()) {
			return;
		}

		try {
			if (this._renderContainer.requestFullscreen) {
				this._renderContainer.requestFullscreen();
			} else if (this._renderContainer.msRequestFullscreen) {
				this._renderContainer.msRequestFullscreen();
			} else if (this._renderContainer.mozRequestFullScreen) {
				this._renderContainer.mozRequestFullScreen();
			} else if (this._renderContainer.webkitRequestFullscreen) {
				this._renderContainer.webkitRequestFullscreen();
			}
		} catch (exception) {
			this._handleError(exception);
		}
	},

	exitFullScreen: function () {
		if (this.isiOSDevice()) {
			$j('body').toggleClass('iOSFullScreen');
			$j(this._renderContainer).toggleClass('iOSFullScreenElement');
			return;
		}

		try {
			let result = null;
			if (document.exitFullscreen) {
				result = document.exitFullscreen();
			} else if (document.msExitFullscreen) {
				result = document.msExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				result = document.mozCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				result = document.webkitExitFullscreen();
			}

			if (result && result.catch) {
				//Workaround: Fängt folgenden Fehler ab: Uncaught (in promise) TypeError: Document not active
				result.catch(function () { });
			}
		} catch (exception) {
			this._handleError(exception);
		}
	},

	/**
	 * @param {String} startSceneId
	 */
	setStartSceneId: function (startSceneId) {
		this._startSceneId = startSceneId;
	},

	enableRaycaster: function () {
		this._raycaster.setEnabled(true);
	},

	disableRaycaster: function () {
		this._raycaster.setEnabled(false);
	},

	/**
	 * Parameter kann sein: 'low', 'normal', 'high'
	 * @param {String} quality
	 */
	setRenderQuality: function (quality) {
		if (this._renderQuality === quality) {
			return;
		}

		this._renderQuality = quality;

		let pixelRatio = 1;
		switch (quality) {
			case 'low':
				let quality = 1300 / window.innerWidth * window.devicePixelRatio;
				if (quality >= 0.75) {
					quality = 0.75;
				}
				pixelRatio = quality.toFixed(2);
				break;
			case 'normal':
				pixelRatio = 1;
				break;
			case 'high':
				pixelRatio = window.devicePixelRatio;
				break;
			default:
				if (window.console) {
					console.warn('setRenderQuality: Ungültige Qualitätsstufe ', quality);
				}
		}

		this._renderer.setPixelRatio(pixelRatio);
	},

	/**
	 * @returns {String|Null}
	 */
	getRenderQuality: function () {
		return this._renderQuality;
	},

	/**
	 * Parameter kann sein: 'low', 'normal', 'high'
	 * @param {String} quality
	 */
	setVideoQuality: function (quality) {
		if (this._videoQuality === quality) {
			return;
		}

		this._videoQuality = quality;
		$j('body').trigger('aptisGlobalVideoQualityChanged', [quality]);
	},

	/**
	 * @returns {String}
	 */
	getVideoQuality: function () {
		return this._videoQuality;
	},

	/**
	 * @returns {Null|THREE.OrbitControls|THREE.DeviceOrientationControls}
	 */
	getCurrentControls: function () {
		if (this._currentControlType === 'device-orientation' && this._controlsDeviceOrientationControls) {
			return this._controlsDeviceOrientationControls;
		} else {
			return this._controlsOrbitControls;
		}
	},

	/**
	 * @returns {Null|THREE.OrbitControls}
	 */
	getOrbitControls: function () {
		return this._controlsOrbitControls;
	},

	/**
	 * @returns {Boolean}
	 */
	isInEditor: function () {
		return $j('#editorContainer').length > 0;
	},

	enableStereoView: function () {
		if (this._stereoEffect === null) {
			this._stereoEffect = new THREE.StereoEffect(this._renderer);
		}
		this._resize()
	},

	disableStereoView: function () {
		this._stereoEffect = null;
		this._resize()
	},

	/**
	 * @return {Boolean}
	 */
	isStereoViewEnabled: function () {
		return this._stereoEffect !== null;
	},

	/**
	 * @returns {Number}
	 */
	getWorldId: function () {
		return this._worldId;
	},

	/**
	 * @returns {Boolean}
	 */
	hasDeviceOrientationControls: function () {
		return this._controlsDeviceOrientationControls !== null;
	},

	/**
	 * @returns {String}
	 */
	getCurrentControlType: function () {
		return this._currentControlType;
	},

	/**
	 * @returns {Null|aptis.virtualReality.engine.VRScene}
	 */
	getCurrentScene: function () {
		return this._currentScene;
	},

	/**
	 * @returns {URLSearchParams}
	 * @private
	 */
	_getUrlParams: function () {
		if (this._urlParams === null) {
			this._urlParams = new URLSearchParams(window.top.location.href);
		}
		return this._urlParams;
	},

	/**
	 * @returns {Boolean}
	 */
	isEngineReady: function () {
		return this._engineIsReady;
	},

	/**
	 * @private
	 */
	_activateStartButton: function () {
		let timeWait = this._debugModeEnabled ? 0 : 2000;
		setTimeout(function () {
			$j('#startVrEngineButton').removeAttr('disabled');
			$j('#startVrEngineButton .start-button-text').text('VR starten'); //TODO i18n
		}, timeWait);
	},

	/**
	 * @private
	 */
	_disableStartButton: function () {
		$j('#startVrEngineButton').attr('disabled', 'disabled');
		$j('#startVrEngineButton .start-button-text').text('Starte...'); //TODO i18n
	},

	/**
	 * @returns {{x: (Number), y: (Number)}}
	 */
	getStartFocusPosition: function () {
		const startVrObject = this.findObjectById(this._getUrlParams().get('startObject'));
		if (startVrObject) {
			return {
				x: startVrObject.getPositionX(),
				y: startVrObject.getPositionY(),
			};
		}
		let startScene = this.findSceneById(this._startSceneId);
		if (!startScene) {
			startScene = this._scenes[0];
		}
		if (!startScene) {
			return {
				x: 0,
				y: 90,
			};
		}
		return {
			x: startScene.getStartPositionX() || 0,
			y: startScene.getStartPositionY() || 90,
		};
	},

	/*
	 * @param {MouseEvent} event
	 * @private
	 */
	_clickedHandler: function (event) {
		if (!this.isEngineReady()) {
			return;
		}

		let positionX = event.clientX;
		let positionY = event.clientY;
		if (this.isMobileDevice() && event.changedTouches) {
			positionX = event.changedTouches[0].clientX;
			positionY = event.changedTouches[0].clientY;
		}
		let mousePosition = this._calculateCenteredPosition(positionX, positionY, this._renderElementJQuery.width(), this._renderElementJQuery.height());

		if (this._currentScene && event.target && $j(event.target).is('.aptisVirtualRealityCanvas')) {
			this._raycaster.check(this._currentScene, 'clicked', mousePosition);
		}

		this._headUpDisplayController.clickedHandlerCheck(event.type, mousePosition);
	},

	/**
	 * @param {Number} positionX
	 * @param {Number} positionY
	 * @param {Number} canvasWidth
	 * @param {Number} canvasHeight
	 * @returns {THREE.Vector2}
	 * @private
	 */
	_calculateCenteredPosition: function (positionX, positionY, canvasWidth, canvasHeight) {
		let canvasBoundingRect = this._renderElementJQuery.get(0).getBoundingClientRect();
		//Berechnung der Zentrierten Mausposition IM Canvas
		//Berechnung der Maus Position im Canvas
		let mouseX = (positionX - canvasBoundingRect.left) / (canvasBoundingRect.right - canvasBoundingRect.left) * canvasWidth;
		let mouseY = (positionY - canvasBoundingRect.top) / (canvasBoundingRect.bottom - canvasBoundingRect.top) * canvasHeight;
		//Normalisieren der Position um einen Wert zwischen +/-1 zu bekommen
		//X ist zwischen -1(links) und +1(rechts)
		//Y ist zwischen -1(unten) und +1 (oben)
		return new THREE.Vector2(((mouseX / canvasWidth) * 2 - 1), (- (mouseY / canvasHeight) * 2 + 1));
	},

	/**
	 * @private
	 */
	_updateFov: function () {
		const currentScene = this.getCurrentScene();
		if (currentScene) {
			if (!this._fovFrustum || !this._cameraViewProjectionMatrix) {
				this._fovFrustum = new THREE.Frustum();
				this._cameraViewProjectionMatrix = new THREE.Matrix4();
			}

			// this._camera.updateMatrixWorld();
			// this._camera.matrixWorldInverse.getInverse(this._camera.matrixWorld);
			// this._cameraViewProjectionMatrix.multiplyMatrices(this._camera.projectionMatrix, this._camera.matrixWorldInverse);
			// this._fovFrustum.setFromMatrix(this._cameraViewProjectionMatrix);

			// currentScene.updateObjectsForFov(this._fovFrustum);
		}
	},

	/**
	 * @private
	 */
	_rotateCameraWithKeyboard: function () {
		if (!this._currentKeyPressed) {
			return;
		}

		let rotationSpeed = 1;
		if (new Date().getTime() - this._lastKeyPressedTime > 1000) {
			rotationSpeed = 3;
		}

		let rotationDeltaX = 0;
		let rotationDeltaY = 0;
		switch (this._currentKeyPressed) {
			case 38: // up
				rotationDeltaY = (this._rotationExactY <= 175) ? rotationSpeed : 0;
				break;
			case 37: // left
				rotationDeltaX = rotationSpeed;
				break;
			case 40: // down
				rotationDeltaY = (this._rotationExactY >= 5) ? -rotationSpeed : 0;
				break;
			case 39: // right
				rotationDeltaX = -rotationSpeed;
				break;
		}
		this.getObjectPositionManager().setPosition(this.getCurrentCamera(), this._rotationExactX + rotationDeltaX, this._rotationExactY + rotationDeltaY, -0.000000000001);
	},

	/**
	 * @return {aptis.virtualReality.engine.VRAnimationCreator}
	 */
	getAnimationCreator: function () {
		if (!this._animationCreator) {
			this._animationCreator = new aptis.virtualReality.engine.VRAnimationCreator(this.getObjectPositionManager(), this);
		}
		return this._animationCreator;
	},

	/**
	 * @param {String} vrObjectId
	 * @return {String[]|Null}
	 */
	getVisibleRulesFromObject: function (vrObjectId) {
		return this._ruleController.getVisibleRulesFromObject(vrObjectId);
	},

	/**
	 * @param {String} vrObjectId
	 * @param {String[]} visibleRules
	 */
	setVisibleRule: function (vrObjectId, visibleRules) {
		this._ruleController.setVisibleRule(vrObjectId, visibleRules);
	},

	/**
	 * @param {String} vrObjectId
	 * @return {String[]|Null}
	 */
	getHiddenRulesFromObject: function (vrObjectId) {
		return this._ruleController.getHiddenRulesFromObject(vrObjectId);
	},

	/**
	 * @param {String} vrObjectId
	 * @param {String[]} hiddenRules
	 */
	setHiddenRule: function (vrObjectId, hiddenRules) {
		this._ruleController.setHiddenRule(vrObjectId, hiddenRules);
	},

	/**
	 * @returns {aptis.RestCommunicator}
	 */
	getRestCommunicator: function () {
		if (!this._restCommunicator) {
			this._restCommunicator = new aptis.RestCommunicator('');
		}
		return this._restCommunicator;
	},

	/**
	 * @returns {Null|aptis.virtualReality.engine.VRRuleController}
	 */
	getRuleController: function () {
		return this._ruleController;
	},

	/**
	 * @returns {Object}
	 */
	getCopyrightLogo: function () {
		return this._copyrightLogo;
	},

	/**
	 * @param {Object} image
	 */
	setCopyrightLogo: function (image) {
		this._copyrightLogo = image;
	},

	/**
	 * @returns {String|Null}
	 */
	getCopyrightLogoPath: function () {
		return this._copyrightLogo.mediumPath || null;
	},

	/**
	 * @param imagePath
	 */
	setCopyrightLogoPath: function (imagePath) {
		this.setCopyrightLogo({
			type: 'image',
			mediumPath: imagePath,
			transparent: true,
		});
	},

	/**
	 * @returns {Object}
	 */
	getWorldAmbientAudio: function () {
		return this._worldAmbientAudio;
	},

	/**
	 * @param {String} audioPath
	 */
	setWorldAmbientAudioPath: function (audioPath) {
		this.setWorldAmbientAudio({
			'type': 'audio',
			'mediumPath': audioPath,
		});
	},

	/**
	 * @returns {null|String}
	 */
	getWorldAmbientAudioPath: function () {
		if (!this._worldAmbientAudio) {
			return null;
		}
		return this._worldAmbientAudio.mediumPath;
	},

	/**
	 * @param {Object} audio
	 */
	setWorldAmbientAudio: function (audio) {
		this._worldAmbientAudio = audio;
		// this.getMediaController().unload('audioBackground');
		this.startCurrentCorrectAmbientAudio();
	},

	startCurrentCorrectAmbientAudio: function () {
		if (this._currentScene && this._currentScene.hasAmbientAudio()) {
			this._currentScene.startAmbientAudio();
		} else if (this.hasAmbientAudio()) {
			this._startAmbientAudio();
		}
	},

	/**
	 * @returns {Boolean}
	 */
	hasAmbientAudio: function () {
		return this._worldAmbientAudio && this._worldAmbientAudio.mediumPath;
	},

	/**
	 * @private
	 */
	_startAmbientAudio: function () {
		if (this.hasAmbientAudio()) {
			this.getMediaController().play('audioBackground', this._worldAmbientAudio.mediumPath, this._worldAmbientAudioReferenceId, 0, true);
		}
	},

	/**
	 * @returns {Object}
	 */
	getPreviewBackgroundImage: function () {
		return this._previewBackgroundImage;
	},

	/**
	 * @param {Object} image
	 */
	setPreviewBackgroundImage: function (image) {
		this._previewBackgroundImage = image;
	},

	/**
	 * @returns {String|Null}
	 */
	getPreviewBackgroundImagePath: function () {
		return this._previewBackgroundImage.mediumPath || null;
	},

	/**
	 * @param imagePath
	 */
	setPreviewBackgroundImagePath: function (imagePath) {
		this.setPreviewBackgroundImage({
			type: 'image',
			mediumPath: imagePath,
			transparent: false,
		});
	},

	/**
	 * @returns {String|Null}
	 */
	getSocialMediaPreviewImagePath: function () {
		return this._socialMediaPreviewImage.mediumPath || null;
	},

	/**
	 * @returns {String|Null}
	 */
	getSocialMediaPreviewImage: function () {
		return this._socialMediaPreviewImage;
	},

	/**
	 * @param imagePath
	 */
	setSocialMediaPreviewImagePath: function (imagePath) {
		this.setSocialMediaPreviewImage({
			type: 'image',
			mediumPath: imagePath,
			transparent: false,
		});
	},

	/**
	 * @param {Object} image
	 */
	setSocialMediaPreviewImage: function (image) {
		this._socialMediaPreviewImage = image;
	},

	/**
	 * @returns {aptis.virtualReality.editor.VRHelperLines|Null}
	 */
	getHelperLines: function () {
		return this._helperLines;
	},

	/**
	 * @returns {string}
	 */
	getEmbedHtml: function () {
		const url = $j(this._destinationSelector).data('world-preview-url');
		return `<iframe width="560" height="315" src="${url}" frameborder="0"></iframe>`;
	},

	/**
	 * @return {aptis.virtualReality.engine.VRSoundEffectController}
	 */
	getSoundEffectController: function () {
		return this._soundEffectController;
	},

	/**
	 * @return {aptis.virtualReality.engine.VRNotificationController}
	 */
	getNotificationController: function () {
		return this._notificationController;
	},

	/**
	 * @returns {Boolean}
	 */
	cursorIsMouse: function () {
		return !this.isMobileDevice();
	},

	stopMobileVrMode: function () {
		if (!this.isVrModeEnabled()) {
			return;
		}

		this.disableStereoView();
		this.exitFullScreen();
		this.switchControls('orbit');
		this.setIsVrModeEnabled(false);
		$j('body').trigger('aptis-vrModeStopped');
		$j('#virtualRealityContainer #rotate-mobile-device').remove();
	},

	startMobileVrMode: function () {
		const me = this;

		if (this.isVrModeEnabled()) {
			return;
		}

		if (window.innerWidth > window.innerHeight) {
			me.enableStereoView();
		}
		this.makeFullScreen();
		this.switchControls('device-orientation');
		this.setIsVrModeEnabled(true);
		$j('body').trigger('aptis-vrModeStarted');
		$j('#virtualRealityContainer').append('<div id="rotate-mobile-device"></div>');
	},

	/**
	 * @param {Boolean} isVrModeEnabled
	 */
	setIsVrModeEnabled: function (isVrModeEnabled) {
		this._isVrModeEnabled = isVrModeEnabled;
	},

	/**
	 * @returns {Boolean}
	 */
	isVrModeEnabled: function () {
		return this._isVrModeEnabled;
	},

	/**
	 * @private
	 */
	_orientationChangHandler: function () {
		const me = this;

		setTimeout(function () {
			if (window.innerWidth > window.innerHeight && me.isVrModeEnabled()) {
				me.enableStereoView();
			} else {
				me.disableStereoView();
			}
		}, 1000);
	},

	/**
	 * @return {aptis.virtualReality.engine.IconManager}
	 */
	getIconManager: function () {
		return this._iconManager;
	},

	/**
	 * @returns {aptis.virtualReality.engine.VRObjectDestroyer}
	 */
	getObjectDestroyer: function () {
		if (!this._objectDestroyer) {
			this._objectDestroyer = new aptis.virtualReality.engine.VRObjectDestroyer();
		}
		return this._objectDestroyer;
	},

	/**
	 * @return {Boolean}
	 */
	isInScorm: function () {
		if ($j('#virtualRealityContainer.aptisVirtualRealityScormContainer').length > 0) {
			return true;
		} else {
			return false;
		}
	},

	/**
	 * Hier wird geprüft ob sich die Welt in einem iFrame mit einer bestimmten Klasse befindet
	 *
	 * @returns {boolean}
	 */
	isEmbedded: function () {
		return $j(window.frameElement).is('.aptis-vr-embedded');
	},

	/**
	 * @param {Object} profileData
	 */
	showProfile: function (profileData) {
		if (this._profilePageController) {
			this._profilePageController.show(profileData);
		}
	},

	/**
	 * @returns {Null|Object}
	 */
	getSocketConfig: function () {
		return this._socketConfig;
	},

	/**
	 * @returns {String}
	 */
	getCreatorUserIdOfWorld: function () {
		return this._creatorUserIdOfWorld;
	},

	/**
	 * @returns {aptis.virtualReality.engine.VRSocketManager|Null}
	 */
	getSocketManager: function () {
		return this._socketManager;
	},

	/**
	 * @returns {aptis.virtualReality.engine.VRWebRtcController|Null}
	 */
	getWebRtcController: function () {
		return this._webRtcController;
	},

	/**
	 * @returns {aptis.MessageManager|Null}
	 */
	getMessageManager: function () {
		return this._messageManager;
	},
});
